interface ISysTable {
    id: string;
    label: string;
    name: string;
    number_ref: string;
    parent_table_name?: string | null;
    created_at: Date;
    updated_at: Date;
}

class SysTable {
    constructor();
    constructor(data: ISysTable);
    constructor(data?: ISysTable) {
        this.id = data?.id || "";
        this.label = data?.label || "";
        this.name = data?.name || "";
        this.number_ref = data?.number_ref || "";
        this.parent_table_name = data?.parent_table_name || null;

        this.created_at = new Date();
        this.updated_at = new Date();
    }

    id: string;
    label: string;
    name: string;
    number_ref: string;
    parent_table_name: string | null;
    created_at: Date;
    updated_at: Date;
}

export default SysTable;